export default __webpack_public_path__ + "static/media/icon-11.58727c6e.png";